import React from "react"
import { getAvatarUri } from "../../lib/utils"

export default function UIAvatar({ name, size, ...props }) {
  return <img src={ getAvatarUri(name, size) } alt='Avatar' title={ name } { ...props }/>
}



// WEBPACK FOOTER //
// ./src/components/fragments/UIAvatar.js